import React, { useEffect, useState } from "react";
import Comp from "./Reviewcomp/Comp.js";
import './Userreview.css'
function Userreview() {
  const [index, setIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const reviews = [
        { src: "https://wallpapers.com/images/featured/cool-profile-picture-87h46gcobjl5e4xu.jpg",name: 'Rajat Varma',description :"Good service, no downtime. No complaints so far. Using Royal broadband from the last 1.5 years.", rating:5 },
        { src: "https://i.pinimg.com/736x/67/b4/96/67b49639339ccdadf672c78cc77a58b9.jpg" , name: 'Krishna Patel',description :"Spoken to the provider, he asked a few relevant questions regarding usage and suggested a budget friendly plan that is suitable according to my work. I got the setup done quickly as promised. Great Service!",rating:4.5},
        { src: "https://i.pinimg.com/236x/a6/bc/64/a6bc64bf4eefbca2184982167f576325.jpg" , name: 'Aadhya Srivastava',description :"Good service, I got installation within a day, thanks To Royal team for such a timely response.", rating:5},
        { src: "https://cdn4.sharechat.com/img_339999_366f2823_1674232336351_sc.jpg?tenant=sc&referrer=pwa-sharechat-service&f=351_sc.jpg" , name: 'Neana Hariyani',description :"Very good service. The provider gave proper responses to my queries, he also suggested a cost plan according to my usage type. Even I got the installation done within a few hours. Thank you Royal for the excellent service.", rating:5},
        
    ];

    useEffect(() => {
        const Rtimer = setTimeout(() => {
            setAnimating(true);
            setTimeout(() => {
                setIndex((index + 1) % reviews.length);
                setAnimating(false);
            }, 1000); // This should match the CSS animation duration
        }, 4000);

        return () => clearTimeout(Rtimer);
    }, [index, reviews.length]);
return (
    <div className="review-slider-container">
    <div className={`review-slider-wrapper ${animating ? 'animate' : ''}`} style={{ transform: `translateX(-${index * 100}%)` }}>
        {reviews.map((item, idx) => (
            <Comp 
            key={idx}
            url={item.src}
            name={item.name}
            description={item.description}
            rating={item.rating}
            />
        ))}
    </div>
    </div>
  )
}

export default Userreview;
